module.exports = __webpack_public_path__ + "static/carousel-slide-01-d2c59a6c2852b516c5a6f7ee39cdea0e.png";